import { defaultHttpClient } from '../../httpClient';

export const disagreeMarketingAlarm = async (
  type: 'SMS' | 'PUSH' | 'NIGHT_PUSH',
) => {
  const pathMap: Record<'SMS' | 'PUSH' | 'NIGHT_PUSH', string> = {
    SMS: 'sms_agreement',
    PUSH: 'push_agreement',
    NIGHT_PUSH: 'push_agreement/night',
  };

  return await defaultHttpClient.request<void>({
    method: 'DELETE',
    url: `/api/v2/members/me/${pathMap[type]}`,
  });
};
